import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=b1e7eb8e"
import script from "./left-menu.vue?vue&type=script&lang=tsx"
export * from "./left-menu.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports